import type { Tq1VesselDetailsM } from "../models/tq1-vessel-details.models";
import { validateTq1VesselDetails } from "./tech-form-validations";

export const getAllWlthcFieldsDefined = (form: Tq1VesselDetailsM) =>
  !Object.keys(validateTq1VesselDetails(form)).some((key) => key.startsWith("wlthc."));

export const getAllContactDetailsFieldsDefined = (
  form: Tq1VesselDetailsM,
): { contactErrors: Array<Record<string, boolean>> } => {
  const contactErrors: Array<Record<string, boolean>> = [];

  form.contactDetails.forEach((contact, index) => {
    const errors: Record<string, boolean> = {};
    const isProviderRequired = ["Satellite", "Telex", "Other", "Fax", ""].includes(contact.communicationType);

    if (!contact.communicationType || (index === 0 && contact.communicationType !== "Email")) {
      errors.communicationType = true;
    }

    if (isProviderRequired && !contact.provider) {
      errors.provider = true;
    }

    if (!contact.prefix) {
      errors.prefix = true;
    }

    if (!String(contact.details ?? "").trim()) {
      errors.details = true;
    }

    if (!contact.location && contact.communicationType !== "Email") {
      errors.location = true;
    }

    contactErrors[index] = errors;
  });

  return { contactErrors };
};
